<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I62nF5/tc-custom/9781400203864.jpg?1706411581874" alt="This image is the cover for the book Who Do You Think You Are?"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Who Do You Think You Are?
      </h1>
      <p class="bookDescription body article font2">
        <p></p><p>WHO ARE YOU?</p><p>WHAT DEFINES YOU?</p><p>WHAT IS YOUR IDENTITY?</p><p>How you answer those questions affects every aspect of your life: personal, public, and spiritual. So it’s vital to get the answer right.</p><p>Pastor and best-selling author Mark Driscoll believes false identity is at the heart of many struggles—and that you can overcome them by having your true identity in Christ. In <i>Wh</i><i>o Do </i><i>You Th</i><i>i</i><i>n</i><i>k </i><i>Y</i><i>o</i><i>u Are</i><i>?</i>, Driscoll explores the question, “What does it mean to be ‘in Christ’?” In the process he dissects the false-identity epidemic and, more important, provides the only solution—Jesus.</p><p>“This book will give you an unshakeable, biblical understanding of who you are in Christ. When you know who you are, you’ll know what to do.”</p><p>—Craig Groeschel, Senior Pastor of LifeChurch.tv and author of <i>Soul D</i><i>et</i><i>ox</i><i>, </i><i>Clean Livi</i><i>ng </i><i>i</i><i>n </i><i>a </i><i>Cont</i><i>am</i><i>in</i><i>at</i><i>ed </i><i>W</i><i>or</i><i>ld</i></p><p>“I spent years in ministry for Christ without understanding my identity in Christ. I know now that I was not alone. When, by the grace of God, we understand who we are in Christ, everything else can crumble and we will still be standing. I highly commend this book to you.”</p> —Sheila Walsh, speaker and author of <i>God Loves Broken People</i><p></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Driscoll
      </h2>
      
      <p class="authorDescription body article"><P>Mark Driscoll is one of the 50 most influential pastors in America, and the founder of Mars Hill Church in Seattle (www.marshillchurch.org), the Paradox Theater, and the Acts 29 Network which has planted scores of churches. Mark is the author of <I>The Radical Reformission</I>: <I>Reaching Out Without Selling Out</I>. He speaks extensively around the country, has lectured at a number of seminaries, and has had wide media exposure ranging from NPR’s <I>All Things Considered</I> to the <I>700 Club</I>, and from <I>Leadership Journal</I> to <I>Mother Jones</I> magazine. He’s a staff religion writer for the <I>Seattle Times</I>. Along with his wife and children, Mark lives in Seattle.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8250a60c